// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1moQY","noInteraction":"EventWrapper_noInteraction__l3OIA","pointerPassthrough":"EventWrapper_pointerPassthrough__2a4xD"};